import { API_ROUTES } from 'utils/constants';
import { RequestHelper } from 'utils';

const refreshToken = token => RequestHelper.POST(API_ROUTES.LOGIN_REFRESH(), { refreshToken: token });

const UserService = {
  refreshToken
};

export default UserService;